import React, { useState, useEffect } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import "./subservicesTabs.scss";
import "./subservicesTabsResponsive.scss";
import { useTranslation } from "react-i18next";

import ico01 from "../../assets/imgs/iconos/services_home/org_congresos.svg";
import ico02 from "../../assets/imgs/iconos/services_home/transporte.svg";
import ico03 from "../../assets/imgs/iconos/services_home/hospedaje.svg";
import ico04 from "../../assets/imgs/iconos/services_home/gubernamental.svg";
import ico05 from "../../assets/imgs/iconos/services_home/bilingue.svg";
import ico06 from "../../assets/imgs/iconos/services_home/prod_visual.svg";
import ico07 from "../../assets/imgs/iconos/services_home/tour.svg";

export const SubservicesTabs = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [itemSubservices, setItemSubservices] = useState([]);
  const { t } = useTranslation();
  useEffect(() => {
    const contentSubservices = [
      {
        id: 1,
        ico: ico01,
        picture: require("../../assets/imgs/subservices/gestion.png"),
        nameSubservice: "Gestión de eventos",
        infoService:
          "Estamos orientados a satisfacer las necesidades específicas de tu marca, servicio, producto y/o evento de una manera única y creativa, cuidando cada detalle.",
        subTitle1: "Logística completa.",
        infoTitulo1:
          "Los eventos empresariales pueden ser un éxito o fracaso todo depende de la organización del mismo.",
        subTitle2: "Escenografía y stands.",
        infoTitulo2:
          "Eventos para público externo que permite a las empresas mostrar y ofrecer sus productos y servicios.",
      },
      {
        id: 2,
        ico: ico02,
        picture: require("../../assets/imgs/subservices/transporte.png"),
        nameSubservice: "Transporte terrestre y aéreo.",
        infoService:
          "Realizamos la operación y logística de transporte para toda persona o empresa que requiera tarifas preferenciales a nivel nacional e internacional, con acceso inmediato y haciendo de su viaje, la mejor experiencia abordo. ",
        subTitle1: "Tu viaje desde casa.",
        infoTitulo1:
          "La transportación terrestre y aérea requiere una logística a través de una planificación de rutas eficientes y eficaces.",
      },
      {
        id: 3,
        ico: ico03,
        picture: require("../../assets/imgs/subservices/hotel.png"),
        nameSubservice: "Hospedaje y Catering.",
        infoService:
          "Tenemos relación directa con diversas cadenas hoteleras a nivel nacional, lo cual nos ha privilegiado en tener las mejores tarifas para cualquier rubro o sector.",
        subTitle1: "Comodidad y confort.",
        infoTitulo1:
          "Hacemos que cada experiencia sea digna de memorar dentro de los mejores complejos hoteleros.",
        subTitle2: "Oferta gastronómica.",
        infoTitulo2:
          "Seduce a tus invitados con exquisitos platos y maridajes perfectos en medio de una decoración especial.",
      },
      {
        id: 4,
        ico: ico04,
        picture: require("../../assets/imgs/subservices/gob.png"),
        nameSubservice: "Apoyo gubernamental.",
        infoService:
          "Buscamos el apoyo mediante trámites legales dirigidas a dependencias y organismos que forman parte del gobierno del lugar de tu evento.",
        subTitle1: "Solicitudes y permisos.",
        infoTitulo1:
          "Contamos con el equipo necesario para la gestión de solicitudes y permisos para congresos.",
      },
      {
        id: 5,
        ico: ico05,
        picture: require("../../assets/imgs/subservices/bilingue.png"),
        nameSubservice: "Personal bilingüe.",
        infoService:
          "Sabemos del mundo globalizado en el que vivimos, es por ello que contamos con el personal bilingüe capacitado para una atención amable, cordial y sobre todo humana para tus invitados internacionales.",
        subTitle1: "Comunicación sin limites.",
        infoTitulo1:
          "Contamos con un equipo con el uso apropiado de los idiomas y la facilidad para expresarse por escrito correctamente.",
      },
      {
        id: 6,
        ico: ico06,
        picture: require("../../assets/imgs/subservices/produccion.png"),
        nameSubservice: "Producción y postproducción.",
        infoService:
          "También realizamos videos corporativos, de marketing, publicidad, presentación de productos, animaciones para redes sociales y mucho más, todo esto lo podemos transmitir dentro de tu evento o de forma digital.",
        subTitle1: "¡Luces, cámara y acción!",
        infoTitulo1:
          "Contamos con un equipo de técnicos expertos y las mejores herramientas para una proyección en forma digital y durante tu evento presencial.",
        subTitle2:
          "¡Sorprende a tus invitados con audiovisuales atractivos en tu evento!",
        // infoTitulo2:
        //   "vvv - Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ",
      },
      {
        id: 7,
        ico: ico07,
        picture: require("../../assets/imgs/subservices/tour.png"),
        nameSubservice: "Tour de acompañantes.",
        infoService:
          "Nuestros guías ofrecen una experiencia única al facilitar direcciones y comentarios sobre atracciones turísticas, culturales, históricas, y arqueológicas del lugar de tu evento.",
        subTitle1: "Comunicación total.",
        infoTitulo1:
          "Trabajamos con un amplio personal con dominio de diversos idiomas que fungen como guías turísticos durante tu evento para los acompañantes de tus invitados.",
      },
    ];
    setItemSubservices(contentSubservices);
  }, []);

  return (
    <div className="wrapper_subservices">
      <div className="content_subservices_tabs">
        <div className="container-lg ">
          <div className="section_tabs">
            <h2 className="ttls ttl_section c_morado text-center">
              {t("Nos encargamos de todo")}
            </h2>
            <p className="paragraph lg c_marin fw_500 text-center">
              {t("Nuestros servicios")}
            </p>
            <Nav tabs>
              {itemSubservices.map((itemSubservice) => (
                <NavItem key={itemSubservice.id}>
                  <NavLink
                    className={
                      activeTab === `${itemSubservice.id}` ? "active" : ""
                    }
                    onClick={() => setActiveTab(`${itemSubservice.id}`)}
                  >
                    <div className="item_tabs_group">
                      <div className="text-center">
                      <img src={itemSubservice.ico} alt="" />
                      </div>
                      <h6>{t(itemSubservice.nameSubservice)}</h6>
                    </div>
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
            <TabContent activeTab={activeTab}>
              {itemSubservices.map((itemSubservice) => (
                <TabPane key={itemSubservice.id} tabId={`${itemSubservice.id}`}>
                  <div className="content_tabs_group">
                    <div className="row">
                      <div className="col-md-7 ">
                        <div className="box_info_tabs">
                          <h3 className="ttls ttl_section c_morado mb-4">
                            {t(itemSubservice.nameSubservice)}
                          </h3>
                          <p className="paragraph lg">
                            {t(itemSubservice.infoService)}
                          </p>
                        </div>
                        <div className="box_subinfo_tabs">
                          <div className="row">
                            <div className="col-md-6 mb-5">
                              <h3 className="mt-1 ttlsb">
                                {t(itemSubservice.subTitle1)}
                              </h3>
                              <p className="paragraph sm">
                                {t(itemSubservice.infoTitulo1)}
                              </p>
                            </div>
                            <div className="col-md-6 mb-5">
                              <h3 className="mt-1 ttlsb">
                                {t(itemSubservice.subTitle2)}
                              </h3>
                              <p className="paragraph sm">
                                {t(itemSubservice.infoTitulo2)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div className="box_infoimgs_tabs">
                          {itemSubservice?.nameSubservice !==
                          "Gestión de eventos" ? (
                            <img
                              src={itemSubservice.picture}
                              alt="Gestion de eventos"
                            />
                          ) : (
                            <>
                              <iframe
                                className="IfremeGestionEventos"
                                width={550}
                                height={100}
                                src="https://cdn.knightlab.com/libs/juxtapose/latest/embed/index.html?uid=aff0495a-ff04-11ed-b5bd-6595d9b17862"
                              ></iframe>
                              <div className="TapaLogo"></div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPane>
              ))}
            </TabContent>
          </div>
        </div>
      </div>
    </div>
  );
};
